/**
 * Slider.ts
 */

// Because the file is too big, Using CDN for swiper
// import Swiper from 'swiper';

const Slider = (() => {

    let options = {
        initElem: document.getElementsByClassName('js-slider')
    }

    function init() {

        if(options.initElem.length) {

            initSlider();

            if(EWDS_DEBUG) {
                console.log('[DEBUG] Slider : initialized');
            }
        }

    }

    function initSlider() {

        function getOffset() : number {
            let elem = document.getElementById('js-slider-title');
            let pos = elem.getBoundingClientRect();
            return pos.x;
        }

        // Init each swiper

        const swipers = options.initElem;

        for (let i = 1; i <= swipers.length; i++) {

            let swiperParams: SwiperOptions = {
                slidesPerView: 1.3,
                spaceBetween: 15,
                slidesOffsetBefore: getOffset(),
                slidesOffsetAfter: getOffset(),
                keyboard: {
                    enabled: true,
                },
                pagination: {
                    el: `.swiper-pagination-${i}`,
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.3,
                        spaceBetween: 15,
                    },
                    1024: {
                        slidesPerView: 3.3,
                        spaceBetween: 20,
                    },
                    1366: {
                        slidesPerView: 3.8,
                        spaceBetween: 20,
                    },
                    1536: {
                        slidesPerView: 4.2,
                        spaceBetween: 20,
                    },
                    1920: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    },
                },
                on: {
                    resize: function() {
                        this.setTranslate(getOffset());
                    },
                    // setTranslate(...args) {
                    //     // Debugging offset
                    //     console.log(args);
                    // }
                }
            };

            let carousel = new Swiper(`.swiper-${i}`, swiperParams);
        }
        
    }

    return {
        init: init
    };

})();

export default Slider;